import { isAllowedAccount, type FirebaseUser } from '@citibox-panel/auth';
import { forgetGoogleAccessToken } from './googleToken';
import { queryClient } from './queryClient';
import { noteSessionUser } from './tabHandoff';

// Everything the previous person left in memory: their cached reads (PII of «Usuarios») and the
// Google token that writes to the Amazon sheet in their name.
export function resetSessionState(): void {
  void queryClient.cancelQueries();
  queryClient.clear();
  forgetGoogleAccessToken();
}

// Runs before the next user renders, on every uid change: the sign-out button, expiry, another tab
// or an account switch all drain the same way.
export function handleUserChange(_previous: FirebaseUser | null, next: FirebaseUser | null): void {
  resetSessionState();
  // An account outside the domain is signed out again at once: it is nobody whose tabs the next
  // person could inherit or keep.
  noteSessionUser(next !== null && isAllowedAccount(next.email) ? next.uid : null);
}
